// Nội dung hướng dẫn 1 tính năng: ưu tiên bản admin sửa (feature_configs.huong_dan, trang admin Cấu hình tính năng),
// trống thì đọc file public/kienthuc/<slug>.md như cũ. Ảnh quy định (admin bật "hiện quy định") nối dưới hướng dẫn.
const API_URL = process.env.REACT_APP_CUNGVEDICH_API_URL || 'https://api.cungvedich.vn/api';

export const taiHuongDan = async (slug) => {
  let huongDan = '';
  let anh = [];
  try {
    const res = await fetch(`${API_URL}/feature-config/huong-dan/${encodeURIComponent(slug)}`);
    const d = res.ok ? (await res.json())?.data : null;
    if (d) { huongDan = d.huongDan || ''; anh = d.anhQuyDinh || []; }
  } catch { /* mạng lỗi → dùng file */ }
  if (!huongDan) {
    try {
      const res = await fetch(`/kienthuc/${slug}.md?v=${Date.now()}`);
      const text = res.ok ? await res.text() : '';
      // SPA fallback trả index.html khi không có file
      if (text && !text.trimStart().startsWith('<')) huongDan = text;
    } catch { /* bỏ qua */ }
  }
  if (anh.length) huongDan += `\n\n## 📜 Quy định\n\n${anh.map((u, i) => `![Quy định ${i + 1}](${u})`).join('\n\n')}\n`;
  return huongDan || 'Chưa có nội dung hướng dẫn.';
};
